<rid-mechanic-background />

@let _state = state();

<rid-mechanic-wrapper>
  <rid-top-bar class="block w-full" name="Dictee | Zinnen" [steps]="sentences().length" [progress]="index()" />

  <rid-mechanic-content>
    @if (title(); as mechanicTitle) {
      <rid-mechanic-title [title]="mechanicTitle" />
    }

    <div class="flex flex-col items-center gap-8">
      <div class="relative">
        <rid-audio-button src="FOR SIZING" size="LARGE" class="pointer-events-none invisible" />

        @for (input of [sentenceKey()]; track input) {
          <rid-audio-button
            #audioButton
            class="absolute inset-0"
            [src]="{ pronounce: this.sentence() }"
            size="LARGE"
            animate.enter="wait-500 anim-pop-in"
            animate.leave="anim-fade-out"
            ridSfx="BUBBLE_POP"
            (animationend)="$event.animationName === 'pop-in' ? start() : undefined"
          />
        }
      </div>

      @if (_state === 'FEEDBACK') {
        <div
          class="font-family-din text-text-primary mx-auto max-w-6xl rounded-3xl border-2 border-slate-200 bg-white px-8 py-6 text-center text-3xl shadow-lg shadow-slate-900/8 xl:px-10 xl:py-7 xl:text-4xl"
          animate.enter="anim-pop-in"
          animate.leave="anim-pop-out"
          ridSfx="HINT"
        >
          @for (word of sentenceWords(); track $index) {
            @let isSelected = isWordSelected($index);
            <button
              class="mx-1 inline rounded-xl border-2 px-2 py-1 align-baseline transition-colors outline-none"
              type="button"
              [class]="
                isSelected
                  ? 'border-red-300 bg-red-50 text-red-500 underline decoration-3 underline-offset-4'
                  : isWordClickable()
                    ? 'cursor-pointer border-transparent text-slate-700 hover:border-slate-200 hover:bg-slate-50'
                    : 'border-transparent text-slate-700'
              "
              [disabled]="!isWordClickable()"
              (click)="toggleWord($index, !isSelected)"
            >
              {{ word }}
            </button>
          }
        </div>
      }
    </div>

    @if (_state === 'WRITING') {
      <rid-bottom-button content="Klaar!" animate.enter="wait-2000" (clicked)="onDone()" />
    }

    @if (showAssessmentToast()) {
      <rid-assessment-toast (assessed)="$event === 'CORRECT' ? markCorrect() : markIncorrect()" />
    }

    @if (showContinueButton()) {
      <rid-bottom-button content="Volgende" [disabled]="selectedWordIndices().length === 0" (clicked)="next()" />
    }

    <rid-overlay-feedback #overlayFeedback />
  </rid-mechanic-content>
</rid-mechanic-wrapper>
